import React, { FC, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import {
  Container,
  TabText,
  TabWrapper,
  AddInfoContainer,
  AddInfoText,
  NumberBadge,
  DoneIndicator,
} from './styles'

type TabsProps = {
  tabs:any[],
  size:'small' | 'display',
  checked?:boolean,
  isSteps?:boolean,
  location?:any,
  onChange?:(tab:any) => void,
  block?:any,
  greyBack?:boolean,
  blockNavigate?:boolean,
  customStyles?:any,
}
type ItemTab = {
  item:any,
  tabs:any[],
  size:'small' | 'display',
  isSteps?:boolean,
  last?:any,
  location?:any,
  onChange?:(tab:any) => void,
  checked?:boolean,
  blocked?:boolean,
  blockNavigate?:boolean
}

const buildNextTabPath = (pathname: string, tabs: any[], nextSlug: string): string => {
  const segments = pathname.split('/').filter(Boolean)
  const tabSlugs = new Set(tabs.map((tab) => String(tab.slug)))
  const firstTabSegmentIndex = segments.findIndex((segment) => tabSlugs.has(segment))

  if (firstTabSegmentIndex >= 0) {
    return `/${[...segments.slice(0, firstTabSegmentIndex), nextSlug].join('/')}`
  }

  const normalizedPathname = pathname.endsWith('/') ? pathname.slice(0, -1) : pathname

  return `${normalizedPathname}/${nextSlug}`
}

const Tabs:FC<TabsProps> = ({blockNavigate, block, tabs, size, onChange, checked, isSteps, location, greyBack, customStyles}) => {
  const routerLocation = useLocation()
  const pathSegments = routerLocation.pathname.split('/').filter(Boolean)
  const routeTab = tabs.find((tab:any) => pathSegments.includes(String(tab.slug)))?.slug
  const activeLocation = routeTab ?? location

  return (
    <Container role="tablist" style={customStyles} greyBack={greyBack} isSteps={isSteps}>
      {tabs.map((item:any, index:any) => {
        const blockedTab = item.slug === block?.route && block?.isBlock
        const currentTabIndex = tabs.findIndex((tab:any) => tab.slug === activeLocation)
        const completedTab = !blockedTab && Boolean(checked && (activeLocation === 'finally' || currentTabIndex > index))
        const completedInfo = !blockedTab && Boolean(checked && (activeLocation === 'finally' || currentTabIndex >= index))

        return(
        <div key={item.id} style={isSteps ? {display:"flex", width:'100%', flexDirection:'column'} : {display:"flex"}}>
          <TabItem
            tabs={tabs}
            location={activeLocation}
            isSteps={isSteps}
            blocked={blockedTab}
            size={size}
            item={item}
            onChange={onChange}
            blockNavigate={blockNavigate}
            checked={completedTab}
          />
          {item.additional_info ? 
            <AddInfoContainer>
              <AddInfoText active={completedInfo}>
                {item.additional_info}
              </AddInfoText>
            </AddInfoContainer>
          : null}
        </div>
      )})}
    </Container>
  )
}

export default Tabs

const TabItem:FC<ItemTab> = ({blockNavigate, blocked, item, tabs, size, isSteps,last, location, checked, onChange}) => {
  const [hover, setHover] = useState<boolean>(false)
  const navigate = useNavigate()
  const routerLocation = useLocation()
  const active = !blocked && Boolean(location === item.slug || checked || item.checked)
  return (
    <TabWrapper
      type="button"
      role="tab"
      disabled={blocked}
      aria-selected={active}
      onClick={blocked ? undefined : onChange ? () =>  {
        if(!blockNavigate){
          navigate(buildNextTabPath(routerLocation.pathname, tabs, item.slug))
        }
        onChange(item.slug) 
      } : () => {}}
      isSteps={isSteps}
      onMouseEnter={() => blocked ? undefined : setHover(true)}
      onMouseLeave={() => setHover(false)}
      $blocked={blocked}
      $checked={checked}
      active={active} size={size}>
      <TabText as="span" isSteps={isSteps} hover={isSteps ? false : hover} active={active}>
        {item.title}
      </TabText>
      {item.number !== undefined || item.count !== undefined ?
        <NumberBadge as="span" $blocked={blocked} hover={hover} active={active}>
          {item.number ?? item.count}
        </NumberBadge>
      : null}
      {checked ? 
        <DoneIndicator aria-hidden="true">✓</DoneIndicator>
      :
        null
      }
    </TabWrapper>
  )
}
